<script lang="ts">
  export let element: HTMLElement = null;

  export let root: HTMLElement = null;
  export let rootMargin: string = "0px";
  export let threshold: number = 0;
  export let once: boolean = true;
  export let entry: any = null;
  export let intersecting: boolean = false;

  import { tick, onDestroy, afterUpdate } from "svelte";

  let prevElement = null;
  let observer = undefined;

  afterUpdate(async () => {
    await tick();
    if (element != null && element != prevElement && observer) {
      observer.observe(element);
      if (prevElement != null) {
        observer.unobserve(prevElement);
      }
      prevElement = element;
    }
  });

  function processRootMargin(input: string): string {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const parts = input.split(" ").map((part) => {
      if (part.endsWith("vw")) {
        return `${(parseFloat(part) * vw) / 100}px`;
      } else if (part.endsWith("vh")) {
        return `${(parseFloat(part) * vh) / 100}px`;
      } else {
        return part;
      }
    });

    return parts.join(" ");
  }

  onDestroy(() => {
    if (observer) {
      observer.disconnect();
    }
  });

  $: if (typeof window !== "undefined") {
    try {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((_entry) => {
            entry = _entry;
            intersecting = _entry.isIntersecting;
            if (intersecting && once) {
              observer.unobserve(element);
            }
          });
        },
        { root, rootMargin: processRootMargin(rootMargin), threshold }
      );
    } catch (e) {
      intersecting = true;
    }
  }
</script>

<slot {intersecting} {entry} />
